/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createDataActionHook, IActionContext, IActionInput, IMSDyn365Window } from '@msdyn365-commerce/core';
import { Cart } from '@msdyn365-commerce/retail-proxy';
import { IProductInfo, TelemetryEvent } from '@msdyn365-commerce/telemetry-internal';
import { getProductInfoFromCartLinesAsync } from './telemetry.action.helper';

declare let window: IMSDyn365Window;

/**
 * CopyCart data action pre-hook
 * @param inputs Data action inputs
 */
const beforeCopyCart = async (inputs: IActionInput | IActionInput[]) => {
    // placeholder
};

/**
 * Fires an CheckOut event after CopyCart data action completed
 * @param _inputs Data action inputs
 * @param cart New checkout cart
 * @param actionContext Action context
 */
const afterCopyCart = async (_inputs: IActionInput | IActionInput[], cart: Cart | Cart[], actionContext: IActionContext) => {
    if (window && window._msdyn365 && window._msdyn365.telemetry) {
        const cartObject = Array.isArray(cart) ? cart[0] : cart;
        let cartLineProductUnits: IProductInfo[] = [];

        // Collect info on products in the cart
        if (cartObject && cartObject.CartLines && Array.isArray(cartObject.CartLines) && cartObject.CartLines.length > 0) {
            try {
                cartLineProductUnits = await getProductInfoFromCartLinesAsync(cartObject.CartLines, actionContext);
            } catch (error) {
                actionContext.telemetry.error('CopyCart post-data action hook failed to process cart lines.', error);
            }
        }

        // Fire Checkout event
        window._msdyn365.telemetry.logEvent(TelemetryEvent.CheckOut, {
            cartId: cartObject.Id,
            cartVersion: cartObject.Version ? cartObject.Version.toString() : '',
            products: cartLineProductUnits,
            orderId: cartObject.OrderNumber ? cartObject.OrderNumber.toString() : ''
        });
    }
};

createDataActionHook({
    actionId: '@msdyn365-commerce/retail-proxy/Carts/Copy',
    postReaderHook: afterCopyCart,
    preReaderHook: beforeCopyCart
});
